<template>
  <div
    v-if="condition !== null">
    <label class="label">
      {{ label }}
    </label>
    <validation-provider :name="label">
      <div
        class="activity-result-input">
        <ActivityResultConditionInitButton
          v-if="isShowInitButton"
          :condition="condition"
          @click="onClickInitButton" />
        <select
          v-else
          :ref="condition.name"
          :value="value"
          class="input-item"
          @input="onInput">
          <option
            v-for="option of condition.options"
            :key="option.value"
            :value="option.value"
            :disabled="option.value === -1">
            {{ option.label }}
          </option>
        </select>
      </div>
    </validation-provider>
  </div>
</template>

<script>
import ActivityResultConditionInitButton from '@/components/parts/ActivityResultConditionInitButton.vue'
export default {
  components: {
    ActivityResultConditionInitButton
  },
  props: {
    condition: {
      type: Object,
      default: null
    },
    value: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      isShowInitButton: false,
    }
  },
  computed: {
    label() {
      return this.condition.label
    }
  },
  created() {
    if (this.value == null) {
      this.isShowInitButton = true
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event.target.value)
    },
    onClickInitButton() {
      this.isShowInitButton = false
      this.$emit('input', this.condition.initValue)
      this.$nextTick(() => {
        this.$refs[this.condition.name].focus()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.label {
  margin-bottom: 5px;
  text-align: center;
  width: 100%;
}

.activity-result-input {
  background-color: $white;
  color: $l-blue;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.input-item {
  background: none;
  color: $l-blue;
  border: none;
  width: 100%;
  height: 100%;
  text-align: center;
  text-align-last: center;
}
</style>